import { InQueueManager, Queue } from './in_queue';

declare global {
  interface Window {
    GlobalMBZNamespace: Array<string>;
    [key: string]: unknown;
  }
}

const functionName = window.GlobalMBZNamespace.shift() as string;
const queue = window[functionName] as { q: Queue | Array<unknown> };

// Now replace initialization array with queue manager object
queue.q = InQueueManager(functionName, queue.q as Array<unknown>);
